import React, { useState } from 'react';
import { Phone, X } from 'lucide-react';

const EmergencyBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  const closeBanner = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="bg-orange-500 text-white py-2.5 relative">
      <div className="container mx-auto px-4 flex justify-center items-center">
        <Phone size={16} className="mr-2 flex-shrink-0" />
        <p className="text-sm md:text-base">
          <span className="font-semibold">Elektrische noodsituatie?</span>{' '}
          <span className="hidden sm:inline">Bel ons 24/7 op</span>{' '}
          <a href="tel:0383336549" className="underline font-bold hover:text-orange-100 transition-colors">
            038-3336549
          </a>
        </p>
        <button
          onClick={closeBanner}
          className="absolute right-2 p-1 hover:text-orange-100 transition-colors"
          aria-label="Sluiten"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default EmergencyBanner;
